/*
  Determines whether value param is a real number or equal to 0. Then it
  determines what to return based on the args passed for either of those
  scenarios. It either returns a string, 0 as a number, or the original value
  arg.
*/
import { FALLBACKS, FALLBACK_STRINGS } from "../constants.js";
export var checkForInvalidOrZero = (value, invalidTo, zeroTo) => {
  var isInvalid = typeof value !== 'number' || Number.isNaN(value) || value === Number.POSITIVE_INFINITY || value === Number.NEGATIVE_INFINITY;
  var isZero = value === 0;

  // if invalid
  if (isInvalid && invalidTo !== FALLBACKS.ZERO) return FALLBACK_STRINGS[invalidTo];
  if (isInvalid && invalidTo === FALLBACKS.ZERO) return 0;

  // if zero
  if (isZero && zeroTo !== FALLBACKS.ZERO) return FALLBACK_STRINGS[zeroTo];
  if (isZero && zeroTo === FALLBACKS.ZERO) return 0;
  return value;
};
export default checkForInvalidOrZero;